const StatusBadge = ({ status }) => {
  const normalized = (status || "PENDING").toUpperCase();
  const variants = {
    PENDING: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/25",
    REVIEWED: "bg-primary/15 text-primary dark:text-accent border border-primary/25",
    ACCEPTED: "bg-accent/15 text-primary dark:text-accent border border-accent/30",
    REJECTED: "bg-red-500/15 text-red-700 dark:text-red-400 border border-red-500/25",
  };

  const labels = {
    PENDING: "Pending",
    REVIEWED: "In Review",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
  };

  return (
    <span
      className={`px-2.5 py-1 text-[10px] sm:text-xs font-semibold rounded-full shrink-0 ${
        variants[normalized] || "bg-muted text-muted-foreground border border-border/60"
      }`}
    >
      {labels[normalized] || normalized.replace(/_/g, " ")}
    </span>
  );
};

export default StatusBadge;